export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Favorite-Red-17ce02b48f875a7e5a65c0bc8197d7cd.svg";